import {
  ConfirmationDialog,
  type ConfirmationActionType,
  type ConfirmationDialogType,
} from "@wombat/ui-kit";

// hooks
import { useStore } from "../contexts/dataStore.context";

// components
import { Babel } from "./Language/Babel";

export type { ConfirmationActionType };
export type ConfirmationModalType = ConfirmationDialogType;

export const ConfirmationModal: React.FC = () => {
  const [modal] = useStore<ConfirmationModalType>("confirmationModal");
  const [open, setOpen] = useStore<boolean>("confirmationModal.open");

  return (
    <ConfirmationDialog
      {...modal}
      open={open}
      onClose={() => setOpen(false)}
      renderText={(value) => <Babel>{value}</Babel>}
    />
  );
};
